export type QixitDistribution = 'web' | 'store';

declare global {
  interface Window {
    __QIXIT_DISTRIBUTION__?: QixitDistribution;
    __QIXIT_STORE_SAFE_MODE__?: boolean;
    __QIXIT_SHELL_VERSION__?: string;
    Capacitor?: {
      isNativePlatform?: () => boolean;
      getPlatform?: () => string;
    };
  }
}

const STORE_SAFE_MODE_ENV = import.meta.env.VITE_STORE_SAFE_MODE === '1';

function hasNativeShell(): boolean {
  try {
    return typeof window !== 'undefined' && !!window.Capacitor?.isNativePlatform?.();
  } catch {
    return false;
  }
}

export function getDistribution(): QixitDistribution {
  if (typeof window === 'undefined') return 'web';

  if (window.__QIXIT_DISTRIBUTION__ === 'store') return 'store';
  if (window.__QIXIT_DISTRIBUTION__ === 'web') return 'web';

  // Fail closed for native shells so purchase UI never flashes open.
  if (hasNativeShell()) return 'store';
  return 'web';
}

export function isStoreSafeModeEnabled(): boolean {
  if (typeof window === 'undefined') return STORE_SAFE_MODE_ENV;
  return STORE_SAFE_MODE_ENV || window.__QIXIT_STORE_SAFE_MODE__ === true;
}

export function isStoreDistribution(): boolean {
  return getDistribution() === 'store' || isStoreSafeModeEnabled();
}

export function isNativeShell(): boolean {
  return hasNativeShell();
}

export function getShellVersion(): string | null {
  if (typeof window === 'undefined') return null;
  return window.__QIXIT_SHELL_VERSION__?.trim() || null;
}
